// @flow
/* 💁 This slice of state will eventually be fleshed out.
Right now we just need to know the username of a user so
as not to self-delete or self-disable */
import type { State as TopLevelState, Action } from '../store';

export type State = {
  username: string,
};

export const getUser = (state: TopLevelState): State => state.user;

export const initialState: State = {
  username: '',
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'LOG_IN':
      return { username: action.payload.username };
    case 'LOG_OUT': {
      return { username: '' };
    }
    default:
      return state;
  }
};
